module.exports = __webpack_public_path__ + "static/media/mymedicare-news.985815ce.jpg";